import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { MatIconModule } from '@angular/material/icon';
import { I18nModule } from '@app/i18n';
import { RouterModule } from '@angular/router';
import { MatMenuModule } from '@angular/material/menu';
import { TranslateModule } from '@ngx-translate/core';
import { ContentHeaderComponent } from '@app/side-nav/content-header/content-header.component';
import { MatChipsModule } from '@angular/material/chips';
import { NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';
import { NavTooltipSellComponent } from './components/nav-tooltip-sell/nav-tooltip-sell.component';
import { NavTooltipInvestComponent } from './components/nav-tooltip-invest/nav-tooltip-invest.component';
import { NavTooltipHowItWorksComponent } from './components/nav-tooltip-how-it-works/nav-tooltip-how-it-works.component';
import { SharedModule } from '@app/@shared/shared.module';

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    ContentHeaderComponent,
    NavTooltipSellComponent,
    NavTooltipInvestComponent,
    NavTooltipHowItWorksComponent,
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    ContentHeaderComponent,
    NavTooltipSellComponent,
    NavTooltipInvestComponent,
    NavTooltipHowItWorksComponent,
  ],
  imports: [
    CommonModule,
    MatIconModule,
    I18nModule,
    RouterModule,
    MatMenuModule,
    TranslateModule,
    MatChipsModule,
    NgbCarouselModule,
    SharedModule,
  ],
})
export class SideNavModule {}
